import { render, staticRenderFns } from "./planDiscountMapping.vue?vue&type=template&id=913945e0&scoped=true"
import script from "./planDiscountMapping.vue?vue&type=script&lang=js"
export * from "./planDiscountMapping.vue?vue&type=script&lang=js"
import style0 from "./planDiscountMapping.vue?vue&type=style&index=0&id=913945e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913945e0",
  null
  
)

export default component.exports